export interface LinkItem {
  label: string;
  value: string;
}

export const FAQ_LINKS: LinkItem[] = [
  {
    label: "FAQs in English",
    value:
      "https://www.invescomutualfund.com/docs/default-source/new-15/sop_faqs_grievanceredressal_mutual_funds_english.DOCX",
  },
  {
    label: "FAQs in Hindi",
    value:
      "https://www.invescomutualfund.com/docs/default-source/new-15/sop_faqs_grievanceredressal_mutual_funds_hindi.DOCX",
  },
  {
    label: "FAQs in Assamese",
    value:
      "https://www.invescomutualfund.com/docs/default-source/new-15/assamese_sop_faqs_grievanceredressal_mutual_funds.docx",
  },
  {
    label: "FAQs in Bengali",
    value:
      "https://www.invescomutualfund.com/docs/default-source/new-15/bengali_sop_faqs_grievanceredressal_mutual_funds.DOCX",
  },
  {
    label: "FAQs in Kannada",
    value:
      "https://www.invescomutualfund.com/docs/default-source/new-15/kannada_sop_faqs_grievanceredressal_mutual_funds.DOCX",
  },
  {
    label: "FAQs in Malayalam",
    value:
      "https://www.invescomutualfund.com/docs/default-source/new-15/malayalam_sop_faqs_grievanceredressal_mutual_funds.DOCX",
  },
  {
    label: "FAQs in Odia",
    value:
      "https://www.invescomutualfund.com/docs/default-source/new-15/oriya_sop_faqs_grievanceredressal_mutual_funds.docx",
  },
  {
    label: "FAQs in Punjabi",
    value:
      "https://www.invescomutualfund.com/docs/default-source/new-15/punjabi_sop_faqs_grievanceredressal_mutual_funds.DOCX",
  },
  {
    label: "FAQs in Tamil",
    value:
      "https://www.invescomutualfund.com/docs/default-source/new-15/tamil_sop_faqs_grievanceredressal_mutual_funds.docx",
  },
  {
    label: "FAQs in Telugu",
    value:
      "https://www.invescomutualfund.com/docs/default-source/new-15/telugu_sop_faqs_grievanceredressal_mutual_funds.DOCX",
  },
];

export const VIDEO_LINKS: LinkItem[] = [
  { label: "Videos in English", value: "https://youtu.be/Xn39LEAuJjM" },
  { label: "Videos in Hindi", value: "https://youtu.be/EjLpyqpkbo4" },
  { label: "Videos in Gujarati", value: "https://youtu.be/wm126e9yLUw" },
  { label: "Videos in Malayalam", value: "https://youtu.be/8sIyKU56siY" },
  { label: "Videos in Odia", value: "https://youtu.be/O8QfBqZQdfc" },
  { label: "Videos in Punjabi", value: "https://youtu.be/MLhf4ksuAF4" },
  { label: "Videos in Assamese", value: "https://youtu.be/ZC504ppDhjo" },
  { label: "Videos in Tamil", value: "https://youtu.be/PwPcyqEMbt8" },
  { label: "Videos in Bengali", value: "https://youtu.be/eUCvoCKFESs" },
  { label: "Videos in Marathi", value: "https://youtu.be/1ojeLW63a1w" },
  { label: "Videos in Kannada", value: "https://youtu.be/m3VWlIX72z4" },
  { label: "Videos in Telugu", value: "https://youtu.be/nEKLlSTybSk" },
];

export const UNCLAIMED_PROCESS_NOTES = {
  headerTitle: "Unclaimed Amount Process Note",
  whatIsUnclaimed: {
    question: "What is unclaimed amount?",
    answer: "Unclaimed amount in mutual fund is where the amount that is due to investors, but remains with the AMC, because the payments of Redemption or IDCW (Dividend) to the investor has not been credited to the investors bank account.",
  },
  whyUnclaimed: {
    question: "Why an amount is unclaimed?",
    answer: "This can happen due to various reasons mainly such as incomplete or incorrect bank details or investor simply forgot to deposit the redemption / IDCW warrant in their bank account and hence the said amount remains as unpaid.",
    answerWeb: "This can happen due to various reason mainly such as incomplete or incorrect bank details or investor simply forgot to deposit the redemption / IDCW warrant in their bank account and hence the said amount remains as unpaid.",
  },
  howProcessed: {
    question: "How is it processed?",
    answer: "This unpaid amount i.e. redemption, IDCW proceeds that accrue to investors, if remain unclaimed, get invested in separate plan(s) post 90 days from the date of issue of the said amount as per the regulatory guidelines.",
  },
  fourPlans: {
    question: "Following are the four plans to which the unclaimed amounts are invested by the AMC:",
    below3Years: {
      title: "Below 3 years",
      plans: [
        "Invesco India Liquid Fund - Unclaimed Redemption Plan",
        "Invesco India Liquid Fund – Unclaimed IDCW Plan"
      ]
    },
    above3Years: {
      title: "Above 3 years",
      plans: [
        "Invesco India Liquid Fund - Unclaimed Redemption Plan",
        "Invesco India Liquid Fund – Unclaimed IDCW Plan"
      ]
    },
    disclaimer: "Unclaimed Amount Plan(s) are launched for the limited purpose of deployment of unclaimed redemption and IDCW (dividend) amounts of the investors and will not be available for regular investments by investors or switches from existing plans/schemes of the Fund."
  },
  howToIdentify: {
    question: "Investor can identify their unclaimed folios through following ways:",
    website: {
      title: "Through AMC website:",
      steps: [
        "1. Investor(s) can visit AMC website and click on the Unclaimed redemption/dividend tab.",
        "2. Enter PAN or Folio details which will be validated with RTA unclaimed database.",
        "3. If validated, Investor needs to enter any two security questions.",
        "4. Once all the details match, name and address of the investor will get populated which would indicate that the investor has an unclaimed amount lying with the AMC."
      ]
    },
    otherPlatforms: {
      title: "Through other platforms:",
      step1: "1. To assist investors in identifying their unclaimed folios, the Mutual Fund Investment Tracing and Retrieval Assistant (MITRA) platform has been established. This platform is jointly hosted by two Qualified RTAs (QRTAs), Computer Age Management Services Limited (CAMS) and KFIN Technologies Limited, acting as register & transfer agents for AMCs.",
      step2Part1: "2. Investors can access the MITRA platform through links available on the websites of MF Central, AMCs, AMFI, the two QRTAs, and SEBI. ",
      step2ClickText: "Click here",
      step2Part2: "to check unclaimed amount on MITRA platform."
    },
    offline: {
      title: "Offline channels:",
      textPart1: "Investor(s) can call on toll-free number ",
      tollFreeNumber: "1800-209-0007",
      textPart2: " between 9.30 AM to 6.00 PM and can obtain details after proper validation or visit in-person to any of the AMC / RTA service centers to seek details of their unclaimed amount. ",
      clickHereText: "Click here",
      textPart3: "for details on unclaimed amount service centers.",
      textPart3Mobile: "to locate your nearest service center."
    }
  }
};
